import { connect } from 'react-redux';
import MaterialMenu from './MaterialMenu';
import { operations } from '../../../../../store/materials';
import * as appCreators from '../../../../../actions/materials';
import {
  canCreateMaterials,
  canViewMaterials,
  isMaterialRbacEnabled,
  canAccessEducatorArea,
} from '../../../../../../core/materials/permissions';
import { getUserPermissionsInCurrentSpace } from '../../../../../../core/utils/permissions';
import { getIsStudent } from '../../../../../../core/selectors/classroom';

const mapStateToProps = (state, ownProps) => {
  const permissions = getUserPermissionsInCurrentSpace(state);
  const isRbacEnabled = isMaterialRbacEnabled(state);

  // In educator area: if user has educator area permission, they can do everything
  // Otherwise, use individual permissions
  const canAccessEA = canAccessEducatorArea(state);
  const canCreate = ownProps.educatorOnly
    ? canAccessEA
    : canCreateMaterials(state);
  const canView = ownProps.educatorOnly ? canAccessEA : canViewMaterials(state);

  return {
    canCreateFolder: canCreate,
    canImportMaterial: canCreate,
    canExportMaterial: canView,
    permissions,
    isRbacEnabled,
    isStudent: getIsStudent(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onCreateFolder: (educatorOnly) =>
    dispatch(operations.createFolder(educatorOnly)),
  onImportMaterial: (params) => dispatch(operations.importMaterial(params)),
  onExportMaterial: (educatorOnly) =>
    dispatch(appCreators.exportMaterial(educatorOnly)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaterialMenu);
